// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"c_8fc86601","loginHolder":"c_30319e2d","login":"c_571b90eb","footer":"c_86329928","formGroup":"c_5365df5c"};